export default "__VITE_ASSET__CBwG5SYp__"